export default __webpack_public_path__ + "static/devesecops-support2-b40a161b42ba7708582dfb555c036e6f.jpg";